import type { ReactNode } from "react";

import { cn } from "@/core/utils/func/cn";

export type PageHeaderProps = {
  title: ReactNode;
  description?: ReactNode;
  actions?: ReactNode;
  /** Ex. `PageBackButton` à gauche du titre (pages détail). */
  back?: ReactNode;
  className?: string;
  titleClassName?: string;
};

/**
 * En-tête de page responsive : titre + description empilés, actions
 * wrap / pleine largeur sur mobile. Pattern à réutiliser sur les pages
 * listes et détail (incrément 2 du plan responsive).
 */
export function PageHeader({
  title,
  description,
  actions,
  back,
  className,
  titleClassName,
}: PageHeaderProps) {
  return (
    <div
      className={cn(
        "flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between",
        className
      )}
    >
      <div className="flex min-w-0 items-start gap-2">
        {back}
        <div className="min-w-0">
          <h1
            className={cn(
              "text-xl font-semibold text-foreground sm:text-2xl",
              titleClassName
            )}
          >
            {title}
          </h1>
          {description ? (
            <div className="mt-1 text-sm text-muted-foreground">
              {description}
            </div>
          ) : null}
        </div>
      </div>
      {actions ? (
        <div className="flex shrink-0 flex-wrap items-center gap-2">
          {actions}
        </div>
      ) : null}
    </div>
  );
}
